class CollectionsFilters extends HTMLElement {
  constructor() {
    super();

    // Define elements
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.closeBtn = this.querySelector(".btn-close");
    const form = this.querySelector("form");
    this.sectionHeaders = this.querySelectorAll(".section-header");
    this.productsOuter = document.querySelector("#products-outer");
    this.productsOuterId = this.productsOuter.dataset.id;
    this.filtersForm = this.firstElementChild;
    this.all_checked = this.querySelectorAll("input[type='checkbox']:checked");
    this.allFiltersCount = this.querySelector("#all-filters-count");

    // Get Tags array
    this.tagsArray = this.getTagsArray();

    // Reset
    const resetBtn = this.querySelector("#filter-reset");
    resetBtn.addEventListener("click", () => {
      this.all_checked = this.querySelectorAll(
        "input[type='checkbox']:checked"
      );
      this.all_checked.forEach((checkbox) => checkbox.click());

      // Set counters
      // this.setCounters()
      const sections = this.querySelectorAll(".section-checkboxes");
      sections.forEach((section) => {
        const count = section.querySelectorAll(
          "input[type='checkbox']:checked"
        ).length;
        section.querySelector(".active-filter-count").innerHTML = count
          ? `(${count})`
          : null;
      });

      this.allFiltersCount.inn;
    });

    // Add event listeners
    this.summary.addEventListener("click", () => {
      this.hideOnClickOutside(this);
    });

    this.closeBtn.addEventListener("click", () => {
      this.closeModal();
    });

    this.setListeners();

    // Toggle panel on section header click
    this.sectionHeaders.forEach((header) => {
      header.addEventListener("click", () => {
        const panel = header.nextElementSibling;
        const open = panel.classList.contains("active");
        const panels = document.querySelectorAll(".section-list.active");
        panels.forEach((p) => p.classList.remove("active"));

        if (open) {
          panel.classList.remove("active");
        } else {
          panel.classList.add("active");
        }
      });
    });

    // Form change event listener
    form.addEventListener("input", (e) => {
      this.productsOuter.classList.add("loading");
    });
    form.addEventListener(
      "input",
      debounce((event) => {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData).toString();

        // Set filter count on parent section
        this.setCounters(event.target);

        // Set Sort By label
        if (event.target.name === "sort_by") {
          event.target
            .closest(".section")
            .querySelector(
              ".active-filter-count"
            ).innerHTML = `(${event.target.dataset.label})`;
        }

        // Get Filter Results
        this.renderPage(searchParams);
      }, 300).bind(this)
    );
  }

  // Methods
  closeModal() {
    this.details.open = false;
  }

  togglePanel(el) {
    const panel = el.nextElementSibling;
    if (panel.classList.contains("active")) {
      panel.classList.remove("active");
    } else {
      panel.classList.add("active");
    }
  }

  // Listen to window location state change and fetch/inject results
  setListeners() {
    const onHistoryChange = (event) => {
      // console.log("popstate", event);
      const searchParams = event.state
        ? event.state.searchParams
        : CollectionFilters.searchParamsInitial;
      if (searchParams === CollectionFilters.searchParamsPrev) return;
      this.renderPage(searchParams, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  renderPage(searchParams, updateURLHash = true) {
    // Set prev filters, to prevent doubling up
    CollectionFilters.searchParamsPrev = searchParams;
    const url = `${window.location.pathname}?section_id=${this.productsOuterId}&${searchParams}`;

    // console.log(url);

    // Render section from Fetch
    CollectionFilters.filterData.some((item) => item.url === url)
      ? this.renderSectionfromCache(url)
      : this.renderSectionFromFetch(url);

    // Update History
    if (updateURLHash) this.updateURLHash(searchParams);
  }

  // FETCH FUNCTIONS
  // --------------------
  // Fetch: Cache
  renderSectionfromCache(url) {
    const html = CollectionFilters.filterData.find((el) => el.url === url).html;
    // console.log("cached html", html);

    // Parse into HTML
    const parsedHtml = new DOMParser().parseFromString(html, "text/html");
    // console.log("from cache");

    // Render
    this.renderProductGridContainer(parsedHtml);
    this.renderFilters(parsedHtml);

    // Dispatch custom event to initCartFns in module
    window.dispatchEvent(new CustomEvent("collectionfilterchange"));
  }

  // Fetch: Fetch
  renderSectionFromFetch(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        // Parse response into HTML
        const html = new DOMParser().parseFromString(responseText, "text/html");

        // Save to Cache, only if value not already cached
        if (!CollectionFilters.filterData.find((val) => val.url === url)) {
          CollectionFilters.filterData = [
            ...CollectionFilters.filterData,
            { html: responseText, url },
          ];
        }

        // console.log("from fetch");

        // RENDER
        this.renderProductGridContainer(html);
        this.renderFilters(html);

        this.productsOuter.classList.add("injected");

        // Dispatch custom event to initCartFns in module
        window.dispatchEvent(new CustomEvent("collectionfilterchange"));
      });
  }

  // RENDER FUNCTIONS
  // --------------------
  // Render: Grid Container
  renderProductGridContainer(html) {
    this.productsOuter.innerHTML =
      html.getElementById("products-outer").innerHTML;

    // Remove loading state
    this.productsOuter.classList.remove("loading");
  }

  // Render: Filters
  renderFilters(html) {
    const tags = html.querySelectorAll("#filters-form .list-item-checkbox");

    // Go through each and update values in live set
    tags.forEach((tag, index) => {
      const twin = this.tagsArray[index].el;
      const twinInput = this.tagsArray[index].input;
      const twinCount = this.tagsArray[index].counter;
      if (tag.classList.contains("disabled")) {
        twin.classList.add("disabled");
        twin.dataset.disabled = "true";
        twinInput.disabled = true;
      } else {
        twin.classList.remove("disabled");
        twin.removeAttribute("dataset-disabled");
        twinInput.removeAttribute("disabled");
      }
      twinCount.innerHTML = tag.dataset.itemCount;
    });
  }

  // Store all tags in an object to access efficiently later
  getTagsArray() {
    const listItems = Array.from(this.querySelectorAll(".list-item-checkbox"));
    return listItems.map((item) => {
      return {
        el: item,
        id: item.id,
        input: item.querySelector("input"),
        counter: item.querySelector(".filter-item-count"),
      };
    });
  }

  // Set counters
  setCounters(el) {
    // Parent section
    const activeTags = el
      .closest(".section-list")
      .querySelectorAll("input[type='checkbox']:checked").length;
    const count = el.closest(".section").querySelector(".active-filter-count");

    // Guard for Sort By input
    if (!count) return;
    count.innerHTML = activeTags ? `(${activeTags})` : null;

    // Set all filters count
    const checkedInputs = this.querySelectorAll(
      "input[type='checkbox']:checked"
    );
    this.allFiltersCount.innerHTML = checkedInputs.length
      ? `(${checkedInputs.length})`
      : null;
  }

  // Push URL to window location
  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  // Click outside
  hideOnClickOutside(element) {
    const outsideClickListener = (event) => {
      if (!element.contains(event.target)) {
        this.closeModal();
        removeClickListener();
      }
    };

    const removeClickListener = () => {
      document.removeEventListener("click", outsideClickListener);
    };

    document.addEventListener("click", outsideClickListener);
  }
}

CollectionsFilters.filterData = [];
CollectionsFilters.searchParamsInitial = window.location.search.slice(1);
CollectionsFilters.searchParamsPrev = window.location.search.slice(1);
customElements.define("collection-filters", CollectionsFilters);
